'use client';

import ReactDOM from 'react-dom';

const Modal = ({ children, isVisible, onClose, closeable = true }) => {
    if (typeof window === 'undefined') {
        return;
    }

    const root = document.getElementById('root');

    const onOverlayClose = () => {
        if (closeable) {
            onClose();
        }
    };

    return isVisible
        ? ReactDOM.createPortal(
              <>
                  <div className="custom-modal-container overlay" onClick={onOverlayClose} />
                  <div
                      className="custom-modal-container content"
                      aria-modal
                      aria-hidden
                      tabIndex={-1}
                      role="dialog">
                      {children}
                  </div>
              </>,
              root
          )
        : null;
};

export default Modal;
